import {FC, useEffect, useState} from "react"
import Localization from "./../Utils/TranslationHelper"

import Hyperlink from "@ingka/hyperlink"
import Text from "@ingka/text"
import "@ingka/text/dist/style.css"
import {IDexfSettings, ITranslations} from "@inter-ikea-kompis/types"
import DexfSettings from "../Utils/DexfSettings"

const Message: FC = () => {
  const [localization, setLocalization] = useState<ITranslations>()

  const [settings, setSettings] = useState<IDexfSettings>()

  useEffect(() => {
    const localization = new Localization()
    localization.getLocalization().then((data) => {
      if (data) {
        setLocalization(data)
      }
    })

    const dexfSettings = new DexfSettings()
    dexfSettings.getSettings().then((data) => {
      if (data) {
        setSettings(data)
      }
    })
  }, [])

  if (!localization) {
    return <></>
  }
  if (!settings) {
    return <></>
  }

  return (
    <div className="container">
      <div className="grid">
        <div dir={settings.localisation.writeDirection} className="message">
          <Text tagName="p" bodySize="l">
            {localization.kompis.decommissionMessageBody}
          </Text>
          <p></p>
          <Hyperlink
            url={
              localization.kompis.decommissionMessageLink
                ? localization.kompis.decommissionMessageLink
                : settings.kompis.urls.homePageLink
            }
            text={localization.kompis.decommissionMessageLinkText}
            color={"grey"}
          />
        </div>
      </div>
    </div>
  )
}

export default Message
